module.exports = __webpack_public_path__ + "static/media/preview_image_DELETE2.b1b3049d.png";